import { initializeApp } from "firebase/app";
import {getAuth,GoogleAuthProvider,signInWithPopup} from 'firebase/auth';


const firebaseConfig = {
  apiKey: "AIzaSyAHwH9V8WVHbp8te5XrcIp7SrmCSgIsXjc",
  authDomain: "intership-2be01.firebaseapp.com",
  projectId: "intership-2be01",
  storageBucket: "intership-2be01.appspot.com",
  messagingSenderId: "839857358759",
  appId: "1:839857358759:web:36055071e8af67962ed882"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth  = getAuth(app)

export const provider = new GoogleAuthProvider();

export const signInWithGoogle =()=>{
    signInWithPopup(auth,provider).then((res)=>{
        
        const name = res.user.displayName;
        const email = res.user.email;

        localStorage.setItem("name",name)
        localStorage.setItem("email",email)
        
      
    }).catch((error => console.log(error)))
}